/**
 * Утилита для генерации и хранения Hardware ID (HWID).
 *
 * HWID — уникальный идентификатор устройства, генерируется один раз
 * и сохраняется в localStorage. Используется для блокировки клонов
 * при BLACKLIST-карточке.
 */

const HWID_STORAGE_KEY = 'hrnb_hardware_id';

/**
 * Генерирует случайный HWID
 * @returns {string} — UUID v4-подобная строка
 */
const generateHwid = () => {
    const hex = '0123456789abcdef';
    const segments = [8, 4, 4, 4, 12];
    return segments
        .map((len) => {
            let s = '';
            for (let i = 0; i < len; i++) {
                s += hex[Math.floor(Math.random() * 16)];
            }
            return s;
        })
        .join('-');
};

/**
 * Возвращает HWID текущего устройства.
 * Если HWID ещё не создан — генерирует и сохраняет.
 * @returns {string} — HWID
 */
export const getHardwareId = () => {
    let hwid = localStorage.getItem(HWID_STORAGE_KEY);
    if (!hwid) {
        hwid = generateHwid();
        localStorage.setItem(HWID_STORAGE_KEY, hwid);
    }
    return hwid;
};